import { render, staticRenderFns } from "./data-privacy.vue?vue&type=template&id=0ac12311&scoped=true&"
import script from "./data-privacy.vue?vue&type=script&lang=js&"
export * from "./data-privacy.vue?vue&type=script&lang=js&"
import style0 from "../../templateAssests/css/listing.css?vue&type=style&index=0&id=0ac12311&scoped=true&lang=css&"
import style1 from "../../templateAssests/css/detail-page.css?vue&type=style&index=1&id=0ac12311&scoped=true&lang=css&"
import style2 from "./data-privacy.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac12311",
  null
  
)

export default component.exports